import { IsBoolean, IsEmail, IsOptional } from 'class-validator';

export class CreateAllowedEmailDto {
  @IsEmail()
  email!: string;

  @IsOptional()
  @IsBoolean()
  isDefault?: boolean;
}
